module.exports = __webpack_public_path__ + "img/step-inactive.f59b9098.svg";